export const OUTBOX_TOPIC = [
    "webhook.deliver",
    "build.start",
    "campaign.dial",
    "retention.sweep",
    "person_data_request.run",
    "payment.reconcile",
    "usage.rollup",
    "agent_version.published",
    "secret.rotated",
    "everypay.notification_paid",
    "everypay.notification_expired",
    "everypay.new_payment",
    "everypay.refund",
    "optimisation_review.run",
    "voice_agent.paused_by_operator",
    // plan-005 OP-11 (design §18.3.4).
    "customer_order_payment.new_payment",
    "customer_order_payment.refund",
    "customer_order_payment.paid",
    "customer_order_payment.expired",
    "customer_order_payment.link_create",
    "customer_order_payment.link_cancel",
    "customer_order_payment.refund_execute",
    "customer_order_payment.placeholder_outcome",
    "sms.send",
    "sms.delivery_report",
    // 2026-09-29 (register 0ai.3): the runtime turned a caller or visitor away on a billing stop
    // (`credit_exhausted`, `trial_exhausted`, `hard_stop_reached`, `budget_reached`); the worker tells
    // the workspace's owners, once until credit is added (or, for a budget, until it changes).
    "billing.admission_refused",
    // 2026-10-02: the paid SMS — the second SMS of a phone order paid online, sent once by the worker.
    "customer_order_payment.paid_sms",
    // plan-015 QSET (IC-DG-8): a survey question set's build, claimed by the factory.
    "survey_question_set.build",
    // plan-015 PRV (IC-DG-8, ADR 0049): a menu preview's extraction, claimed by the factory.
    "document_preview.extract",
    // plan-018 NOTE (ADR 0060): a caller left a message; the hour's coalesced notice.
    "taken_message.recorded",
    "taken_message.coalesce",
    // plan-019 DOM (design §31.3.8): the help assistant's mail, documentation build and budget alert.
    "help_request.created",
    "help_request_reply.created",
    "help_documentation.refresh",
    "help_budget.reached",
    // plan-020 DOM (design §32.7.9, §32.10): the plan subscription's mail and the terms change notice.
    "subscription.mail",
    "subscription.terms_change",
    // 2026-10-18 (owner request): a new organization; the worker tells wetalk's operators.
    "account.created",
    // plan-032 DB-OR (design §43.7, §43.12): an optimisation review finished or failed; the worker tells the requester.
    "optimisation_review.finished",
    // plan-029 PRICE-SEAM (design §40.25.1): a confirmation code was sent and charged; the worker posts its ledger entry.
    "confirmation_code.charged",
    // plan-034 DOM (design §45.29, §45.30.3): the wetalk app's push — the fan-out from a fact, one delivery per phone.
    "push.fan_out",
    "push.deliver",
];
//# sourceMappingURL=outbox-message.js.map